import React, { MouseEvent } from 'react';

interface DesktopListProps {
  countries: Array<{
    Text: string;
    Href: string;
  }>;
}

export const DesktopList = ({ countries }: DesktopListProps) => {
  const selectCountry = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const url = new URL(e.currentTarget.attributes.getNamedItem('href').value);
    document.location.href = url.href;
  };

  const generateDesktopList = (array: typeof countries) => {
    const columns = 4;
    const temparray = [];
    const newArray = [];

    // Put all countries inside li
    array.forEach((element) => {
      temparray.push(
        <li key={element.Text}>
          <a onClick={selectCountry} href={element.Href}>
            {element.Text}
          </a>
        </li>
      );
    });

    const temparraylength = temparray.length;
    const columnsLength = Math.ceil(temparraylength / columns);

    // Split array and put all li inside ui
    for (let i = 0; i < temparraylength; i += columnsLength) {
      const column = temparray.slice(i, i + columnsLength);
      newArray.push(
        <ul key={i} className='c-country-selector-block-list-column'>
          {column}
        </ul>
      );
    }
    return newArray;
  };

  return (
    <div className='c-country-selector-block-list'>
      {countries && generateDesktopList(countries)}
    </div>
  );
};
